import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';

import { getUrlByLoan, goToLoanRoute } from 'navigation/application-routes';
import routes from 'resources/routes.json';
import staticPagesRoutes from 'resources/static-pages-routes.json';

import { CookieHelper } from 'utils/helper/cookie-helper';
import { isMobile } from 'utils/helper/page-behavior-helper.js';

import { getOrCreateDevice } from 'store/actions/customer-actions';
import { logout } from 'store/actions/auth-actions';

import Button from 'components/UI/button/button';

import Logo from './logo';

import styles from './styles.module.scss';
import { getFirstName } from '../../../utils/helper/loan-helper';

export default function Header() {
  const dispatch = useDispatch();
  const showMainHeader = useSelector((state) => state?.utilReducer?.showMainHeader);
  const showMenu = useSelector((state) => state?.utilReducer?.showMenu);
  const loan = useSelector((state) => state?.personalLending?.loan);
  const device = useSelector((state) => state?.customer?.device);
  const [openMenu, setOpenMenu] = useState(false);
  const [onHoverMenuButton, setOnHoverMenuButton] = useState(false);

  const WITHOUT_LOAN_AND_ID = !loan || !loan.id;

  const IS_APP_INSTALL_PAGE =
    window.location.href.includes('/celular/app') || window.location.href.includes('/celular/pre-ap');

  const LOAN_PHASE_IS_APPLICATION = loan.state && [1].includes(loan?.state?.phase?.id);

  useEffect(() => {
    if (!device || !device.kind || !device.code) {
      (async () => {
        const fp = await FingerprintJS.load({
          monitoring: false,
        });
        fp.get().then((fingerprintResult) => getOrCreateCurrentDevice(fingerprintResult));
      })();
    }
  }, []);

  useEffect(() => {
    window.personalLending = window.personalLending ? window.personalLending : {};
    window.personalLending.loan = window.personalLending.loan ? window.personalLending.loan : {};
    window.personalLending.loan.id = loan.id;
  }, [loan]);

  function getOrCreateCurrentDevice(fingerprintResult) {
    const { components } = fingerprintResult;
    const device = { kind: 1, data: { typeName: 'br.com.supersim.service.log.model.device.BrowserData' } };

    Object.entries(components).forEach(([key, { value }]) => {
      device.data[key] = value;
    });

    device.data.plugins = device.data.plugins
      ? device.data.plugins.constructor === Array
        ? device.data.plugins
        : [device.data.plugins]
      : device.data.plugins;
    device.os = device.data.platform;
    device.userAgent = device.data.userAgent;
    device.code = fingerprintResult.visitorId;

    dispatch(getOrCreateDevice(device));
  }

  function goToStartFunil(loan) {
    goToLoanRoute(loan, routes.LOAN_APPLICATION_START, routes.LOAN_APPLICATION_START);
    openCloseMenu();
  }

  function goToLogin(loan) {
    goToLoanRoute(loan, routes.CUSTOMER_LOGIN, routes.CUSTOMER_LOGIN);
    openCloseMenu();
  }

  function appLogout() {
    dispatch(logout(device));
    localStorage.removeItem('loggedIn');
    CookieHelper.remove('SESSION');
    sessionStorage.clear();
    openCloseMenu();
    document.location.reload();
  }

  function openCloseMenu() {
    setOpenMenu(!openMenu);

    if (openMenu) {
      document.body.style.overflow = 'initial';
    } else {
      document.body.style.overflow = 'hidden';
    }
  }

  function onCloseDropdownMenu() {
    setOpenMenu(false);
  }

  if (!showMainHeader) {
    return null;
  }

  return (
    <section id="main-header">
      <header
        id="main-menu"
        style={IS_APP_INSTALL_PAGE && isMobile() ? { position: 'relative', bottom: 100 } : null}
        className={styles.header}
      >
        <Logo showMenu={showMenu} />

        {showMenu && (
          <nav className={`${styles.menu} ${styles.menuRight} ${styles.menuDrop}`}>
            <a className={`${styles.openMenuIcon} clickable`} onClick={openCloseMenu}>
              <FontAwesomeIcon
                icon={faBars}
                size="2x"
                style={{ marginTop: '12px', marginRight: '5px', color: '#2a2b35' }}
              />
            </a>

            <div
              className={`
                ${styles.menu}
                ${styles.menuContentTabletLe}
                ${styles.menuFixedTabletLe}
                ${styles.menuFlexTabletGt}
                ${styles.navWrapper}
                ${openMenu ? styles.navWrapperOpened : styles.navWrapperClosed}
                `}
            >
              <FontAwesomeIcon icon={faTimes} className={styles.closeIcon} onClick={onCloseDropdownMenu} />

              <ul className="center">
                <li>
                  <a href={staticPagesRoutes.INFO_HOW.PATH} onClick={openCloseMenu}>
                    Como fazer o <br />
                    empréstimo pessoal
                  </a>
                </li>

                <li>
                  <a href={staticPagesRoutes.INFO_WHAT.PATH} onClick={openCloseMenu}>
                    Perguntas <br />
                    Frequentes
                  </a>
                </li>

                <li>
                  <a href={staticPagesRoutes.INFO_WHO.PATH} onClick={openCloseMenu}>
                    Quem somos
                  </a>
                </li>

                {loan && loan.id && isMobile() && (
                  <li id="btExit">
                    <a href={staticPagesRoutes.ROOT.PATH} onClick={appLogout}>
                      Sair
                    </a>
                  </li>
                )}

                {(WITHOUT_LOAN_AND_ID || LOAN_PHASE_IS_APPLICATION) && (
                  <li id="btRequest">
                    <Button onClick={() => goToStartFunil(loan)} height="40px" width="140px">
                      Solicitar
                    </Button>
                  </li>
                )}

                {WITHOUT_LOAN_AND_ID ? (
                  <li id="btLoginPage">
                    <Button onClick={() => goToLogin(loan)} height="40px" width="140px" outlined>
                      <span className={styles.menuTitleButton}>Clientes</span>
                    </Button>
                  </li>
                ) : (
                  <li>
                    <div className={styles.dropdown}>
                      <NavLink to={getUrlByLoan(routes.CUSTOMER_LOGIN, loan)}>
                        <Button
                          height="40px"
                          width="auto"
                          minWidth="140px"
                          outlined
                          onMouseEnter={() => setOnHoverMenuButton(true)}
                          onMouseLeave={() => setOnHoverMenuButton(false)}
                        >
                          <span className={styles.menuTitle} style={{ position: 'relative', left: 7 }}>
                            Olá {getFirstName(loan) && '' + getFirstName(loan)}!
                            {onHoverMenuButton ? (
                              <FontAwesomeIcon icon={faAngleUp} className="ml-2" />
                            ) : (
                              <FontAwesomeIcon icon={faAngleDown} className="ml-2" />
                            )}
                          </span>
                        </Button>
                      </NavLink>

                      <div
                        className={styles.dropdownContent}
                        onMouseEnter={() => setOnHoverMenuButton(true)}
                        onMouseLeave={() => setOnHoverMenuButton(false)}
                      >
                        <NavLink className={styles.dropdownItem} to={getUrlByLoan(routes.CUSTOMER_LOGIN, loan)}>
                          Seu empréstimo
                        </NavLink>

                        <a className={styles.dropdownItem} href={staticPagesRoutes.ROOT.PATH} onClick={appLogout}>
                          Sair
                        </a>
                      </div>
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </nav>
        )}
      </header>
    </section>
  );
}
